import React from 'react';
import { Flex, FlexProps } from 'antd';
import { Text } from '@idaho-aeyc/ui-kit';
import styled from 'styled-components';

interface LabeledInfoProps extends FlexProps {
  label: string;
  labelWidth?: number | string;
  children: React.ReactNode;
}

const LabelContainer = styled.div<{ width?: number | string }>`
  width: ${props =>
    typeof props.width === 'number' ? `${props.width}px` : props.width};
  flex-shrink: 0;
`;

const LabeledInfo: React.FC<LabeledInfoProps> = ({
  label,
  labelWidth,
  children,
  ...flexProps
}) => {
  return (
    <Flex {...flexProps}>
      <LabelContainer width={labelWidth}>
        <Text color="#808080">{label}</Text>
      </LabelContainer>
      {children}
    </Flex>
  );
};

export default LabeledInfo;
